import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'mes-monnaies',
  modules: ['auth', 'expert'],
});

Vue.use(Vuex);

const plugins = [vuexLocal.plugin];

export default new Vuex.Store({
  modules,
  plugins,
});
